// UPS Normal (3), FedEx Normal (5), FedEx Domestic USA (10), DHL Express
// (21) - api_path identifies the integration itself, unlike carrier_id,
// which differs per environment for the same integration (e.g. UPS is 16
// on production but 49 on staging). DSV paths (4, 6) are excluded: they
// don't support the pickup flow this gates.
export const PICKUP_ELIGIBLE_API_PATHS = [3, 5, 10, 21];

// Same api_paths, grouped by the carrier label the pickup hub shows in its
// carrier tabs/filter - mirrors PICKUP_CARRIER_API_PATHS in the server's
// shipments.service.ts, which buckets fetchPickups' carrier filter the same
// way. Used to work out which of these an account actually has, rather than
// always offering all three regardless of what's configured.
export const PICKUP_CARRIER_API_PATHS: Record<string, number[]> = {
  UPS: [3],
  FedEx: [5, 10],
  DHL: [21],
};
